module.exports = __webpack_public_path__ + "static/media/add.cfe30e37.gif";